import { ValidationSchema } from "_core/form";
import { CableSetup, ErrorMessages } from "_core/types";

export type FormValues = {
  cableSetup: CableSetup;
};

export const IndraChargerCustomisation: ValidationSchema<{
  cableSetup: string;
}> = {
  cableSetup: ({ cableSetup }) => {
    if (!cableSetup) return ErrorMessages.SELECT_CONNECTION;
  },
};
